import baseAPI from '@/http'

const router = 'api/municipio/municipioTemaPonto'

export const cityThemePointAPI = {
  getTemasFinalizados: (id) => baseAPI.get(`${router}/get-temas-finalizados/${id}`)
}
